import { render, staticRenderFns } from "./CargoCrudRotogramCreate.vue?vue&type=template&id=2264e026"
import script from "./CargoCrudRotogramCreate.vue?vue&type=script&lang=js"
export * from "./CargoCrudRotogramCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports